import React from "react";
import { Box, Grid } from "@mui/material";
import {
    InfoOutlined,
    LockOutlined,
    PublicOutlined,
    RouterOutlined,
} from "@mui/icons-material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";
import { useEBillProviderDetailContext } from "contexts/EBillProviderDetailContext";

const EBillProviderRelayTab = () => {
    const { eBillProviderDetail, loadingEBillProvider } =
        useEBillProviderDetailContext();

    if (loadingEBillProvider) {
        return <InfoGridSkeleton />;
    }

    const relayConfig = eBillProviderDetail?.relayConfig || {};
    const hasRelayAuthValue = Boolean(relayConfig?.authHeaderValue);

    return (
        <Box padding={3}>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={3}>
                    <InformationTile
                        icon={() => <InfoOutlined color="primary" />}
                        title="Relay Enabled"
                    >
                        <Status isActive={relayConfig?.enabled} />
                    </InformationTile>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <InformationTile
                        icon={() => <PublicOutlined color="primary" />}
                        title="Relay Base URL"
                        subtitle={relayConfig?.baseUrl || "N/A"}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <InformationTile
                        icon={() => <LockOutlined color="primary" />}
                        title="Relay Auth Header"
                        subtitle={relayConfig?.authHeaderName || "N/A"}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <InformationTile
                        icon={() => <LockOutlined color="primary" />}
                        title="Relay Auth Value"
                        subtitle={hasRelayAuthValue ? "Configured" : "Not Configured"}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <InformationTile
                        icon={() => <RouterOutlined color="primary" />}
                        title="Target Base URL Header"
                        subtitle={relayConfig?.targetBaseUrlHeader || "X-Forward-To-Base-Url"}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <InformationTile
                        icon={() => <PublicOutlined color="primary" />}
                        title="Provider Base URL"
                        subtitle={eBillProviderDetail?.url || "N/A"}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default EBillProviderRelayTab;